import { Autocomplete } from '@ijoin/components';
import { type GetAdminPlansParams } from '@ijoin/hooks';

import { FC } from 'react';

import { usePlanOptions } from './usePlanOptions';

type Option = { label: string; value: string };

export const PlanAutocomplete: FC<{
  advisoryOrganizationId: null | string | undefined;
  fullWidth?: boolean;
  hideError?: boolean;
  label?: string;
  name?: string;
  params?: GetAdminPlansParams;
  placeholder?: string;
}> = props => {
  const plans = usePlanOptions(props.advisoryOrganizationId, props.params);

  const noOptionsText = props.advisoryOrganizationId
    ? 'No plans for this organization'
    : 'Select an advisory organization first';

  return (
    <Autocomplete<Option>
      fullWidth={props.fullWidth ?? true}
      hideError={props.hideError ?? true}
      label={props.label ?? 'Plan'}
      loading={plans.isLoading}
      name={props.name ?? 'plan'}
      noOptionsText={noOptionsText}
      onInputChange={plans.onSearch}
      options={plans.options}
      placeholder={props.placeholder ?? 'All plans'}
    />
  );
};

PlanAutocomplete.displayName = 'PlanAutocomplete';
